<template>
  <div class="col-md-3">
    <form-group-input
      ref="input"
      type="text"
      :label="label"
      :readonly="readonly"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      v-validate="{ required: required }"
      />
    </div>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-texto-curto",
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Crm/TextoCurto.vue